import apiRequestType from "../apiRequestType";
import { apiConstants } from "../../utils/apiConstants";
import { apiTypes } from "../../utils/apiTypes";

const getShotClasses = (
  Condition,
  Isdistributefilter,
  Status,
  classtype,
  filters,
  locale,
  pageNum,
  pageSize
) => {
  return apiRequestType(
    apiTypes.GET,
    apiConstants.DISTRIBUTE.GET_SHORTCLASSES(
      Condition,
      Isdistributefilter,
      Status,
      classtype,
      filters,
      locale,
      pageNum,
      pageSize
    )
  );
};

export default getShotClasses;
